import { getCurrentUser, getCurrentUserFromStore } from '@lastbrand/fe-common/universal-auth'

import { EMPTY_OBJECT } from '../constants/app'

import isBrowser from './isBrowser'
import toSHA1 from './toSHA1'

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class AuthUtil {
  private static hashedEmail: string

  static getUserHashedEmail = async (): Promise<string | undefined> => {
    if (!isBrowser()) return
    if (AuthUtil.hashedEmail) return AuthUtil.hashedEmail

    try {
      const user = await getCurrentUser()
      const email = user?.attributes?.email
      if (email) {
        const hashedEmail = await toSHA1(email)
        AuthUtil.hashedEmail = hashedEmail
        return hashedEmail
      }
    } catch (error) {
      console.error('Error getting user hashed email:', error)
      // Reset cached value on error
      AuthUtil.hashedEmail = ''
    }
    return undefined
  }

  static getUser = (): { name?: string; email?: string } => {
    if (isBrowser()) {
      const userFromStore = getCurrentUserFromStore()
      const user = userFromStore ? userFromStore : EMPTY_OBJECT
      return user
    }
    return EMPTY_OBJECT
  }

  static isLoggedIn = (): boolean => {
    // For synchronous usage, check localStorage as fallback
    if (!isBrowser()) return false
    const user = getCurrentUserFromStore()
    return !!user
  }

  // eslint-disable-next-line @typescript-eslint/require-await
  static getUserSession = async () => {
    if (isBrowser() && window.getUserSession) {
      return window.getUserSession()
    }
  }
}
